// extracted by mini-css-extract-plugin
module.exports = {"BocconiAndCountry":"styles_BocconiAndCountry__3fg6A","InlineTitle":"styles_InlineTitle__AJ_rp","BoxContainer":"styles_BoxContainer__2YKM3","InfoBox":"styles_InfoBox__2aAtC"};